import React, {useEffect, useRef, useContext, useState} from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import { useCookies } from 'react-cookie';
import fetchOptionsBuilder from '../fetchOptionBuilder';
import WorkflowContext from '../workflowContext';

mapboxgl.accessToken = 'pk.eyJ1IjoianR5dXJrb3ZpY2giLCJhIjoiY2tzaHE4MmM1MXdldzMwczZzbmk4dnBmNiJ9.tuwViMQBAxqbjdj_HWMcog'


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function Map({style}) {
    const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);
    const mapContainer = useRef(null)
    const map = useState(null);

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));

    useEffect(() => {
        // initialise map (only once)
        // if (map.current) return;
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10', // style URL
            center: [-98.5795, 39.8283], // starting position [lng, lat]
            zoom: 3 // starting zoom
        });

        map.current.on("load", () => {
            const formData = new FormData();
            const geo_data = fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "geo_data/json", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
                .then(res => res.json())
                .then(geo_data => {
                    map.current.addSource("infections", {
                        type: "geojson",
                        data: geo_data,
                    });
                    map.current.addLayer({
                        id: "infections-circle",
                        type: "circle",
                        source: "infections",
                        paint: {
                            "circle-color": "#FBB03F",
                            "circle-opacity": 0.9,
                            "circle-radius": 10,
                            "circle-stroke-width": 2,
                            "circle-stroke-color": "#fff"
                        }
                    });
                    map.current.on('click', 'infections-circle', (e) => {
                        // Copy coordinates array.
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        const description =
                            e.features[0].properties.Genome_ID +
                            "<br>Date Inserted: " +
                            e.features[0].properties.Date_Inserted;
        
                        // Ensure that if the map is zoomed out such that multiple
                        // copies of the feature are visible, the popup appears
                        // over the copy being pointed to.
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
        
                        new mapboxgl.Popup()
                            .setLngLat(coordinates)
                            .setHTML(description)
                            .addTo(map.current);
                    });
                })
                .catch(err => {console.log('geo_json map error:', err)});

            // Change the cursor to a pointer when the mouse is over the places layer.
            map.current.on('mouseenter', 'infections-circle', () => {
                map.current.getCanvas().style.cursor = 'pointer';
            });

            // Change it back to a pointer when it leaves.
            map.current.on('mouseleave', 'infections-circle', () => {
                map.current.getCanvas().style.cursor = '';
            });


        });
    }, [workflow]);
    return (
        <div ref={mapContainer} className="map-container" style={style}/>
    );
}
